export const data = [
  {
    label: 'MCR',
    type: 'Previous YTD',
    value: 2800,
    percentage: 20
  },
  {
    label: 'MCR',
    type: 'Current YTD',
    value: 2260
  },
  {
    label: 'DuPont',
    type: 'Previous YTD',
    value: 1800,
    percentage: 30
  },
  {
    label: 'DuPont',
    type: 'Current YTD',
    value: 1300
  },
  {
    label: 'Fluke',
    type: 'Previous YTD',
    value: 950,
    percentage: 20
  },
  {
    label: 'Fluke',
    type: 'Current YTD',
    value: 900
  },
  {
    label: 'Werner',
    type: 'Previous YTD',
    value: 500,
    percentage: 25
  },
  {
    label: 'Werner',
    type: 'Current YTD',
    value: 390
  },
  {
    label: 'Bosch',
    type: 'Previous YTD',
    value: 170,
    percentage: 10
  },
  {
    label: 'Bosch',
    type: 'Current YTD',
    value: 100
  }
];
